module.exports = __webpack_public_path__ + "static/img/Financial-Overview.24683552.gif";